module.exports = __webpack_public_path__ + "assets/images/cockpit/inactive/btn_closedc_off-inactive_ru.png";